import { BaseLayout } from "../layouts";
import { Container, NextPageWithLayout, useAnalytics } from "@akte-mord/common";
import { Typography } from "@mui/material";
import { useRouter } from "next/router";
import React from "react";

export const OrderConfirmationPage: NextPageWithLayout = () => {
  const [email, setEmail] = React.useState("");
  const trackEvent = useAnalytics();
  const router = useRouter();

  React.useEffect(() => {
    const { orderId, email, total, currency } = router.query;
    if (!orderId || !email || !total || !currency) return;

    trackEvent("purchase", {
      transaction_id: orderId as unknown as string,
      value: parseFloat(total as unknown as string),
      currency: currency as unknown as string,
    });

    setEmail(email as unknown as string);
  }, [router, trackEvent]);

  return (
    <React.Fragment>
      <Container>
        <Typography variant="h1" sx={{ pb: 6 }}>
          Vielen Dank!
        </Typography>
        <Typography variant="body1" paragraph>
          Wir haben deine Bestellung erhalten. Eine Bestellbestätigung mit allen Details schicken wir an{" "}
          {email}.
        </Typography>
        <Typography variant="body1" paragraph>
          Solltest du Fragen zu deiner Bestellung haben oder einen Fehler in deiner Lieferadresse
          entdecken, antworte einfach auf die Bestellbestätigung und wir kümmern uns darum.
        </Typography>
      </Container>
    </React.Fragment>
  );
};

OrderConfirmationPage.getLayout = (page) => (
  <BaseLayout title="Bestellung erhalten | Akte Mord® Cold Cases für Zuhause" noindex={true}>
    {page}
  </BaseLayout>
);

export default OrderConfirmationPage;
